"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedMemory = void 0;
exports.shmset = shmset;
exports.shmget = shmget;
const ediabasx_core_1 = require("@emdzej/ediabasx-core");
const register_values_1 = require("./register-values");
class SharedMemory {
    entries = new Map();
    set(key, value) {
        this.entries.set(key, new Uint8Array(value));
    }
    get(key) {
        return this.entries.get(key) ?? new Uint8Array();
    }
    has(key) {
        return this.entries.has(key);
    }
}
exports.SharedMemory = SharedMemory;
function resolveKey(registers, value) {
    const key = typeof value === "string" ? value : (0, register_values_1.getStringValue)(registers, value);
    return key.toUpperCase();
}
function resolveValue(registers, value) {
    if (value instanceof Uint8Array) {
        return new Uint8Array(value);
    }
    if (typeof value === "string") {
        return (0, ediabasx_core_1.utf8ToCp1252)(value);
    }
    return (0, ediabasx_core_1.utf8ToCp1252)((0, register_values_1.getStringValue)(registers, value));
}
function shmset(registers, memory, key, value) {
    const resolvedKey = resolveKey(registers, key);
    const resolvedValue = resolveValue(registers, value);
    memory.set(resolvedKey, resolvedValue);
}
function shmget(registers, memory, destination, key, flags) {
    // Mirrors C# `OpShmget` (EdOperations.cs:2136): writes the stored
    // bytes verbatim via `SetArrayData(byte[])`. Missing key → empty
    // buffer (C# `ByteArray0`). The string path would grow non-zero-
    // tailed payloads by one, breaking any caller that round-trips
    // through `shmset`/`shmget` and length-checks.
    const resolvedKey = resolveKey(registers, key);
    const exists = memory.has(resolvedKey);
    const value = memory.get(resolvedKey);
    (0, register_values_1.setBinaryValue)(registers, destination, value);
    if (flags) {
        flags.c = !exists;
    }
}
//# sourceMappingURL=shared-memory.js.map